import React from 'react';
import ReactDOM from 'react-dom';

import AppTestHarness from './AppTestHarness';

ReactDOM.render(<AppTestHarness />, document.getElementById('root'));
